module.exports = "/_next/static/media/4c4de0b2defc8c2d090b86a32fbd3e05.svg";